module.exports = {
	"header": "Spotin launches new e-com service",
	"date": "2020/12/08",
	"imgSrc": "4.jpg",
	"imgAlt": "Spotin launches new e-com service",
	"ingress": "By: Affärer i Norr (in Swedish)",
	"externalLink": "https://affarerinorr.se/nyheter/2020/december/spotin-lanserar-ny-tjaenst-foer-e-handel/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/4/article.json
// module id = 94
// module chunks = 0